import React from 'react';

const ActivationError = () => {

  return (
    <div className="registration-main">
      <div className="registration__summary registration__summary--error">
        <div className="registration__summary-validation">
          <div className="registration__callout-alert txt-c">
            <p className="registration-main__verification txt-red">Verification Failed</p>
            <p className="registration-main__h3 mt10">
              Verification link expired, or account already verified.
            </p>

          </div>

          <div className="registration__summary-instruct validation">
            <p className="registration__intro-h3">
              <b>Can't find our email?</b>
            </p>

            <p className="registration__intro-h3">
              We'll send the email from "Bet9ja," so you can quickly search for it.
            </p>

            <p className="registration__intro-h3">
              Entered a wrong email address when registering? You can
              <a className="registration__link mr5 ml5" href={server.links.contact_us} title="contact us">contact us</a>
              to update it.
            </p>

            <p className="registration__intro-h3 mt30">
              <b>Contact Us</b>
            </p>

            <p className="registration__intro-h3">
              If you have tried the steps above and still cant find your registration email you
              can <a className="registration__link" href={server.links.contact_us} title="Contact our customer service">
                contact our customer service
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ActivationError;
